
import { CaseDetails, CaseUser } from "@/types"
import { Component, Inject, Prop, Vue } from "vue-property-decorator"
import { CaseEvents } from "@/types/originatingEvents"
import { RecordUserAssignment } from "@/types/assignment"
import { AssignmentMergeType } from "@/types/timeManagement"
import { cloneDeep } from "lodash"
import { updateCaseDetails } from "@/scripts/caseDetails"
import { namespace } from "vuex-class"
import RecordAssignmentService from "@/services/recordAssignmentService"
import { HubConnection } from "@aspnet/signalr"

const caseStore = namespace("cases")

@Component({})
export default class CaseHubEventHandler extends Vue {
	@Inject() recordAssignmentService!: RecordAssignmentService

	@Prop({ required: true }) private readonly currentCase!: CaseDetails | null

	@caseStore.Mutation private removeFieldAwaitingUpdate!: (fieldId: string) => void

	protected render () {
		return null
	}

	public async handleHubRecordEvents (connection: HubConnection) {
		connection.on("caseUpdated", (updatedCase: CaseDetails) => {
			if (this.currentCase) {
				const existingFields = cloneDeep(this.currentCase.fields)
				if (!this.currentCase.isClosed && updatedCase.isClosed) {
					this.$emit("caseClosing")
				}
				updateCaseDetails(this.currentCase, updatedCase)
				if (this.recordAssignmentService) {
					this.recordAssignmentService.updateHoursIfChanged(existingFields)
				}
				if (updatedCase.updatedFieldIds) {
					updatedCase.updatedFieldIds.forEach(fieldId => {
						if (this.currentCase && this.currentCase.fields && this.currentCase.fields[fieldId] &&
							updatedCase.fields && updatedCase.fields[fieldId]) {
							// Update 'required' property for field.

							if (this.currentCase.fields[fieldId].requiredCase !== updatedCase.fields[fieldId].requiredCase) {
								this.currentCase.fields[fieldId].requiredCase = updatedCase.fields[fieldId].requiredCase
							}

							if (this.currentCase.fields[fieldId].requiredRecord !== updatedCase.fields[fieldId].requiredRecord) {
								this.currentCase.fields[fieldId].requiredRecord = updatedCase.fields[fieldId].requiredRecord
							}
						}

						this.removeFieldAwaitingUpdate(fieldId)
					})
				}

				this.$emit("caseUpdated", updatedCase, existingFields)
			}
		})
		connection.on("viewingUsers", (viewingUsers: CaseUser[]) => {
			if (this.currentCase) {
				Vue.set(this.currentCase, "viewingUsers", viewingUsers)
				this.$emit("viewingUsers", viewingUsers)
			}
		})
		connection.on("caseEvents", (caseEvents: CaseEvents) => this.$emit("caseEvents", caseEvents))
		connection.on("caseNoLongerAvailable", () => {
			this.$emit("caseNoLongerAvailable")
		})
		connection.on("assignmentUpdated", (assignments: RecordUserAssignment[], mergeType: AssignmentMergeType) => {
			if (!this.recordAssignmentService) {
				console.error("Update received for record assignments but recordAssignmentService is not available")
			}

			if (mergeType === AssignmentMergeType.Merge || mergeType === AssignmentMergeType.ReplaceForFields) {
				if (this.currentCase) {
					this.recordAssignmentService.removeInvalidAssignments(this.currentCase)
				}
				this.recordAssignmentService.mergeAssignments(assignments, mergeType)
			} else if (mergeType === AssignmentMergeType.Replace) {
				this.recordAssignmentService.assignments = assignments
			} else {
				console.error("Unknown assignment merge type received", mergeType)
			}

			this.$emit("assignmentUpdated", assignments, mergeType)
		})
	}
}
